export default __webpack_public_path__ + "static/media/news.c26e47af.jpg";